import styled from 'styled-components'

export const RewardsHeading2 = styled.h2`
  font-size: 24px;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const RewardsHeading4 = styled.h4`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.component.textDark};
  margin-right: 8px;
  margin-bottom: 0;
`
